/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import moment from 'moment'
import { MdOutlineContentCopy } from 'react-icons/md'
import {
  copyToClipboard,
  reconnectSocket,
  socketConnection
} from '../../_helpers'
import { GrStatusInfo } from 'react-icons/gr'
import { MdOutlineLowPriority } from 'react-icons/md'
import { BsEnvelope } from 'react-icons/bs'
import {
  alertActions,
  coinManagementActions,
  contactUsListActions
} from '../../_actions'
import Loader from '../../components/Atoms/Loader'
import TableData from '../../components/Atoms/Tables/TableData'
import ChatPopup from './components/ChatPopup'
import Pagination from '../../components/Pagination/Pagination'
import sortOptions from '../../_helpers/sortOptions.json'
import ActionModal from './components/ActionModal'
import useDebounce from '../../Custom Hooks/Debounce'

const size = 10
const sortBy = 'updatedAt'
const sortOrder = 'desc'
const CONSTANTS = {
  SUPPORT_CHAT_RELOAD: 'support_chat_reload',
  CONNECTED: 'connected',
  DISCONNECTED: 'disconnect'
}

const ContactUs = () => {
  const dispatch = useDispatch()
  const chatWindowRef = useRef(null)
  const selector = useSelector(state => state)
  const [support, setSupport] = useState([])
  const [pageNo, setPageNo] = useState(1)
  const [keyWord, setKeyWord] = useState('')
  const [fromDate, setFromDate] = useState('')
  const [toDate, setToDate] = useState('')
  const [openModule, setOpenModule] = useState(false)
  const [selectedMsg, setSelectedMsg] = useState(null)
  const [inputValue, setInputValue] = useState('')
  const [chatMessages, setChatMessages] = useState([])
  const [error, setError] = useState('')
  const activeChatRef = useRef(null)
  const sendingRef = useRef(null)
  const [isSending, setIsSending] = useState(false)
  const [isChatLoading, setIsChatLoading] = useState(false)
  const [sortBy1, setSortBy1] = useState('All')
  const [sortBy2, setSortBy2] = useState('All')
  const [count, setCount] = useState(null)
  const [modalOpen, setModalOpen] = useState(false)
  const [modalType, setModalType] = useState(null)
  const [selectedOption, setSelectedOption] = useState('')
  const [selectedData, setSelectedData] = useState(null)
  const [isRefresh, setIsRefresh] = useState(false)
  const [prefillData,setPrefillData] = useState([])

  const truncate = (str, length) => {
    if (length < 3) return str
    return str.length > length ? `${str.substring(0, length - 3)}...` : str
  }

  const debounce = useDebounce(keyWord, 500)

  const getCountList = useCallback(() => {
    coinManagementActions
      .getAmountAndCount({ type: 'CUSTOMER_SUPPORT' })
      .then(res => {
        if (res?.data) {
          setCount(res.data)
        }
      })
      .catch(err => console.error('Error fetching count:', err))
  }, [])

  useEffect(() => {
    getCountList()
  }, [isRefresh])

  const tableHeadings = [
    '#',
    'Ticket ID',
    'User Name',
    'Subject',
    'Description',
    'Priority',
    'Date',
    'Status',
    'Message',
    'Action'
  ]

  const tableRows = support?.map((sup, index) => {
    return [
      (pageNo - 1) * size + (index + 1),
      <span className='flex items-center gap-2 whitespace-nowrap'>
        {sup?.ticketId || '--'}
        {sup?.ticketId && (
          <button
            type='button'
            aria-label={`Copy ticket ID ${sup.ticketId}`}
            onClick={() => copyToClipboard(sup.ticketId, index)}
          >
            <MdOutlineContentCopy />
          </button>
        )}
      </span>,
      <div>
        <p>{sup?.userId?.name}</p>
        <p className='text-gray-500'>{sup?.userId?.email}</p>
      </div>,
      <span
        title={sup?.subject}
        className='flex items-center gap-2'
        key={index}
      >
        {truncate(sup?.subject, 20)}{' '}
        {
          <MdOutlineContentCopy
            className='cursor-pointer'
            onClick={() => copyToClipboard(sup?.subject, index)}
          />
        }
      </span>,
      <span
        title={sup?.description}
        className='flex items-center gap-2'
        key={index}
      >
        {truncate(sup?.description, 20)}{' '}
        {
          <MdOutlineContentCopy
            className='cursor-pointer'
            onClick={() => copyToClipboard(sup?.description, index)}
          />
        }
      </span>,
      sup?.priority ?? 'N/A',
      sup?.createdAt ? moment(sup.createdAt).format('DD-MM-YYYY') : 'N/A',
      <p
        className={`capitalize rounded-full px-2 bg-[#fff] py-1 ${sup?.status === 'in-progress'
          ? 'text-[#FDB52A]'
          : sup?.status === 'open'
            ? 'text-green-500'
            : sup?.status === 'close'
              ? 'text-red-500'
              : 'text-gray-500'
          }`}
      >
        {' '}
        {sup?.status}
      </p>,
      <BsEnvelope
        title='Open Conversation'
        onClick={() => handleChatClick(sup)}
        className='text-[#15A14A] hover:text-green-500 cursor-pointer transition ease-in-out delay-150 hover:-translate-y-1 
        hover:scale-110 duration-300 ml-2'
        size={20}
      />,
      <div className='flex items-center space-x-2'>
        <div className='p-2 rounded-md hover:bg-black/5 cursor-pointer transition'>
          <GrStatusInfo
            className='text-black text-lg'
            title='Status'
            onClick={() => handleAction('STATUS', sup)}
          />
        </div>
        <div className='p-2 rounded-md hover:bg-black/5 cursor-pointer transition'>
          <MdOutlineLowPriority
            className='text-black text-lg'
            title='Priority'
            onClick={() => handleAction('PRIORITY', sup)}
          />
        </div>
      </div>
    ]
  })

  useEffect(() => {
    const data = {
      keyWord: debounce,
      fromDate: fromDate,
      toDate: toDate,
      sortBy: sortBy,
      sortOrder: sortOrder,
      pageNo: pageNo,
      size: size,
      priority: sortBy1,
      status: sortBy2
    }
    if (debounce) {
      data['pageNo'] = 1
      dispatch(contactUsListActions.getSupportList(data))
    } else {
      dispatch(contactUsListActions.getSupportList(data))
    }
  }, [
    debounce,
    fromDate,
    toDate,
    sortOrder,
    sortBy,
    pageNo,
    size,
    sortBy1,
    sortBy2
  ])

  useEffect(() => {
    setSupport(selector?.supportReply?.supportListReply?.data?.list)
  }, [selector?.supportReply?.supportListReply?.data?.list])

  const applyChatUpdate = useCallback((chat, data) => {
    if (activeChatRef.current !== chat) return
    if (data?.message?._id) chat.revision++
    const incoming = data?.message?._id ? [data.message] : data?.messages || []
    if (incoming.length) {
      setChatMessages(previous => {
        const messages = new Map()
        // The socket event and send response may contain the same saved message.
        for (const message of [...previous, ...incoming]) {
          const key = message._id || `${message.sender}:${message.sentAt}:${message.message}`
          messages.set(key, message)
        }
        return [...messages.values()].sort((a, b) =>
          new Date(a.sentAt || 0) - new Date(b.sentAt || 0))
      })
    }
    if (data?.ticketDetails) {
      setSelectedMsg(prev => prev?._id === chat.ticketId
        ? { ...prev, ...data.ticketDetails }
        : prev)
      setSupport(previous => previous?.map(ticket => ticket._id === chat.ticketId
        ? { ...ticket, ...data.ticketDetails }
        : ticket))
    }
  }, [])

  const fetchChatMessages = useCallback(async (chat) => {
    if (!chat || activeChatRef.current !== chat) return
    const revision = chat.revision
    chat.pendingRequests++
    setIsChatLoading(true)
    try {
      const response = await contactUsListActions.getSupportListMessageByPromise({ ticketId: chat.ticketId })
      applyChatUpdate(chat, chat.revision === revision
        ? response.data
        : { ...response.data, ticketDetails: undefined })
    } catch (err) {
      if (activeChatRef.current === chat) dispatch(alertActions.error(err))
    } finally {
      chat.pendingRequests--
      if (activeChatRef.current === chat) setIsChatLoading(chat.pendingRequests > 0)
    }
  }, [applyChatUpdate, dispatch])

  const handleChatClick = data => {
    activeChatRef.current = { ticketId: data._id, revision: 0, pendingRequests: 0 }
    setSelectedMsg(data)
    setOpenModule(true)
    setChatMessages([])
    setInputValue('')
    setError('')
    setIsSending(false)
    setPrefillData(data?.workflow?.steps || [])
    fetchChatMessages(activeChatRef.current)
  }

  const closeMsgPopup = () => {
    activeChatRef.current = null
    setOpenModule(false)
    setSelectedMsg(null)
    setChatMessages([])
    setInputValue('')
    setError('')
  }
  useEffect(() => {
    if (chatWindowRef.current) {
      chatWindowRef.current.scrollTop = chatWindowRef.current.scrollHeight
    }
  }, [chatMessages])

  const onPageChange = page => {
    setPageNo(page)
  }

  const handleMessageSend = async () => {
    const chat = activeChatRef.current
    const message = inputValue.trim()
    if (!chat || sendingRef.current === chat || selectedMsg?.status === 'closed') return
    if (message.length < 2) {
      setError('Message must contain at least 2 characters')
      return
    }
    sendingRef.current = chat
    setIsSending(true)
    setError('')
    try {
      const response = await contactUsListActions.replyMsgTicketAdminByPromise({ ticketId: chat.ticketId, message })
      if (activeChatRef.current === chat) {
        applyChatUpdate(chat, response.data)
        setInputValue('')
      }
    } catch (err) {
      if (activeChatRef.current === chat) dispatch(alertActions.error(err))
    } finally {
      if (sendingRef.current === chat) sendingRef.current = null
      if (activeChatRef.current === chat) setIsSending(false)
    }
  }

  const handleRefresh = () => {
    fetchChatMessages(activeChatRef.current)
  }

  useEffect(() => {
    const chat = activeChatRef.current
    if (!chat) return
    reconnectSocket()
    const chatSocket = socketConnection()
    const joinChat = () => {
      chatSocket.emit(CONSTANTS.CONNECTED, { chatId: chat.ticketId })
    }
    // Reload once the room is joined, including after a network reconnection.
    const handleConnected = () => fetchChatMessages(chat)
    const handleChatUpdate = data => {
      if (data?.ticketId && data.ticketId !== chat.ticketId) return
      if (data?.message?._id) {
        applyChatUpdate(chat, data)
      } else {
        // Status changes and manual reload events still refresh ticket details.
        fetchChatMessages(chat)
      }
    }
    chatSocket.on('connect', joinChat)
    chatSocket.on(CONSTANTS.CONNECTED, handleConnected)
    chatSocket.on(CONSTANTS.SUPPORT_CHAT_RELOAD, handleChatUpdate)
    chatSocket.connect()
    return () => {
      chatSocket.off('connect', joinChat)
      chatSocket.off(CONSTANTS.CONNECTED, handleConnected)
      chatSocket.off(CONSTANTS.SUPPORT_CHAT_RELOAD, handleChatUpdate)
      chatSocket.disconnect()
    }
  }, [selectedMsg?._id, applyChatUpdate, fetchChatMessages])

  const statusCards = [
    {
      title: 'Open',
      count: count?.open,
      icon: <img src='/csemail/Frame.png' alt='wri' className='w-8 h-8' />,
      bgColor: 'bg-indigo-100',
      textColor: 'text-indigo-500'
    },
    {
      title: 'Closed',
      count: count?.closed,
      icon: <img src='/csemail/fi_9859670.png' alt='wri' className='w-8 h-8' />,
      bgColor: 'bg-blue-100',
      textColor: 'text-blue-500'
    },

    {
      title: 'In-Progress',
      count: count?.inProgress,
      icon: (
        <img src='/csemail/07 Writing Idea.png' alt='wri' className='w-8 h-8' />
      ),
      bgColor: 'bg-pink-100',
      textColor: 'text-pink-500'
    },
    {
      title: 'Low',
      count: count?.low,
      icon: <img src='/csemail/fi_2896405.png' alt='wri' className='w-8 h-8' />,
      bgColor: 'bg-red-100',
      textColor: 'text-red-500'
    },
    {
      title: 'Medium',
      count: count?.medium,
      icon: <img src='/csemail/fi_2896405.png' alt='wri' className='w-8 h-8' />,
      bgColor: 'bg-red-100',
      textColor: 'text-red-500'
    },
    {
      title: 'High',
      count: count?.high,
      icon: <img src='/csemail/fi_2896405.png' alt='wri' className='w-8 h-8' />,
      bgColor: 'bg-red-100',
      textColor: 'text-red-500'
    }
  ]

  const StatCard = ({ title, count, icon, bgColor, textColor }) => (
    <div className='flex items-center justify-between p-4 border border-gray-200 rounded-lg bg-[#ffffff]'>
      <div>
        <h3 className='text-lg font-semibold text-gray-800'>{title}</h3>
        <p className='text-2xl font-bold text-gray-900'>{count}</p>
      </div>
      <div className={`${bgColor} ${textColor} p-4 rounded-full`}>{icon}</div>
    </div>
  )

  const onSortByStatus = e => {
    setSortBy1(e.target.value)
    setPageNo(1)
  }
  const onSortByStatus2 = e => {
    setSortBy2(e.target.value)
    setPageNo(1)
  }

  const handleAction = (action, data) => {
    setModalType(action)
    setSelectedData(data)
    if (action === 'STATUS') {
      setSelectedOption(data.status)
    } else {
      setSelectedOption(data.priority)
    }
    setModalOpen(true)
  }
  const handleSelectChange = e => {
    setSelectedOption(e.target.value)
  }

  const handleActionSubmit = async e => {
    e.preventDefault()

    if (!selectedOption || !selectedData) return

    const commonPayload = {
      ticketId: selectedData._id,
      [modalType === 'STATUS' ? 'status' : 'priority']: selectedOption
    }

    const actionMap = {
      STATUS: contactUsListActions.ticketStatusUpdate,
      PRIORITY: contactUsListActions.ticketPriorityUpdate
    }

    try {
      const res = await actionMap[modalType](commonPayload)
      if (res) {
        dispatch(alertActions.success(res?.message || ''))

        const queryData = {
          keyWord,
          fromDate,
          toDate,
          sortBy,
          sortOrder,
          pageNo,
          size,
          priority: sortBy1,
          status: sortBy2
        }

        dispatch(contactUsListActions.getSupportList(queryData))
      }
    } catch (error) {
      dispatch(alertActions.error(error || ''))
    } finally {
      setIsRefresh(prev => !prev)
    }

    setModalOpen(false)
    setSelectedData(null)
  }

  const toggleModal = () => {
    setModalOpen(false)
    setSelectedOption(null)
    setSelectedData(null)
  }

  return (
    <div className='overflow-hidden overflow-y-auto '>
      <Loader loading={selector?.supportReply?.loading || false} />

      <div className='p-3 2xl:p-6 sm:p-5'>
        <div className='grid grid-cols-1 gap-6  md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 '>
          {statusCards.map((card, index) => (
            <StatCard key={`status-${index}`} {...card} />
          ))}
        </div>
        <TableData
          Heading=''
          SubSubHeading=''
          tableHeadings={tableHeadings}
          showExtraHeading={false}
          showFilter={false}
          data={tableRows}
          searchTerm={keyWord}
          setSearchTerm={setKeyWord}
          fromDate={fromDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
          toDate={toDate}
          showExtraAdd={false}
          placeholder={'Search by ticket ID, subject, description...'}
          setPageNo={setPageNo}
          select1={true}
          select2={true}
          option1={sortOptions.option1}
          option2={sortOptions.option2}
          onSortByStatus={onSortByStatus}
          onSortByStatus2={onSortByStatus2}
        />
        {Math.ceil(
          selector?.supportReply?.supportListReply?.data?.total / size
        ) > 1 && (
            <Pagination
              totalPages={Math.ceil(
                selector?.supportReply?.supportListReply?.data?.total / size
              )}
              currentPage={pageNo}
              onPageChange={onPageChange}
            />
          )}
      </div>
      <ChatPopup
        openModule={openModule}
        closeMsgPopup={closeMsgPopup}
        chatWindowRef={chatWindowRef}
        handleSendMessage={handleMessageSend}
        messages={chatMessages}
        error={error}
        setInputValue={setInputValue}
        inputValue={inputValue}
        handleRefresh={handleRefresh}
        isSending={isSending}
        isLoading={isChatLoading}
        prefillData={prefillData}
        selectedMsg={selectedMsg}
        setSelectedMsg={setSelectedMsg}
      />

      <ActionModal
        isOpen={modalOpen}
        option={
          modalType === 'STATUS'
            ? sortOptions.ActionOption2
            : sortOptions.ActionOption1
        }
        modalName={modalType === 'STATUS' ? 'Status' : 'Priority'}
        selectedOption={selectedOption}
        handleOptionChange={handleSelectChange}
        handleSubmit={handleActionSubmit}
        toggleModal={toggleModal}
        message={`Are you sure you want to update the ${modalType?.toLowerCase()} of this ticket?`}
      />
    </div>
  )
}

export default ContactUs
